import { isQrcode } from '@/../config/config';

import qrcode from '@zj/qrcode';
import home from '@views/home';
import intro from '@views/intro';
import game from '@views/game';
import detail from '@views/detail';
import tick from '@views/tickSuccess';
import tickFail from '@views/tickFail';

const routes = [
  {
    path: '/',
    component: home,
    name: 'home',
    children: [
      {
        path: '/qrcode',
        component: qrcode,
        name: 'qrcode',
        meta: { allowBack: false },
      },
      {
        path: '/intro',
        component: intro,
        name: 'intro',
      },
    ],
  },
  {
    path: '/game',
    component: game,
    name: 'game',
    children: [
      {
        path: '/detail',
        component: detail,
        name: 'detail',
      },
      {
        path: '/tick',
        component: tick,
        name: 'tick',
      },
      {
        path: '/tickFail',
        component: tickFail,
        name: 'tickFail',
      },
    ],
  },
];
// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  // mode: "history",
  routes, // （缩写）相当于 routes: routes
});

let allowBack = true; //    给个默认值true
router.beforeEach((to, from, next) => {
  if (!window.activity.isfans && to.name !== 'qrcode' && isQrcode) {
    // console.log(window.activity.isfans);
    router.push({
      name: 'qrcode',
    });
  }

  allowBack = true; //    给个默认值true
  if (to.meta.allowBack !== undefined) {
    allowBack = to.meta.allowBack;
  }
  if (!allowBack) window.history.pushState(null, null, window.location.href);
  next();
});

window.onpopstate = () => {
  if (!allowBack) window.history.go(1); //    这个allowBack 是存在vuex里面的变量
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
